// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__2NuqJ","background--contrast":"section_background--contrast__3rl5m"};